import { DynamicBottomMenu } from 'ui/components';

import { useDynamicBottomMenuLinks } from '../../PageTypes/shared/useDynamicBottomMenuLinks';

export const DynamicBottomMenuFeature: React.FC<Umbraco.DynamicBottomMenu> = ({ content }) => {
	const { title, backButtonLabel, sameLevelNavigation } = content?.properties ?? {};
	const { links, backUrl } = useDynamicBottomMenuLinks(sameLevelNavigation);

	return <DynamicBottomMenu title={title} backButtonLabel={backButtonLabel} backUrl={backUrl} links={links} />;
};
